import React from 'react';
import { useState } from 'react';
import { useWeb3React, UnsupportedChainIdError } from '@web3-react/core';
import {
  InjectedConnector,
  NoEthereumProviderError,
  UserRejectedRequestError as UserRejectedRequestErrorInjected,
} from '@web3-react/injected-connector';
import { WalletConnect } from '@web3-react/walletconnect-v2';
import { ethers } from 'ethers';

// 0 ropsten, 1 bsc
let netid = 0;
let provider = null;
let walletconnect, injected, bsc;

// WalletConnect v2 Project ID - get yours at https://cloud.walletconnect.com
const WALLETCONNECT_PROJECT_ID = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || 'YOUR_PROJECT_ID';

// testnet
const netlist = [
  {
    chaind: 3,
    rpcurl: 'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    blockurl: 'https://ropsten.etherscan.io',
    chainname: 'Ethereum Mainnet',
    chainnetname: 'Ethereum Mainnet',
    chainsymbol: 'ETH',
    chaindecimals: 18,
  },
  {
    chaind: 97,
    rpcurl: 'https://data-seed-prebsc-1-s1.binance.org:8545',
    blockurl: 'https://testnet.bscscan.com/',
    chainname: 'BSC testnet',
    chainnetname: 'BSC testnet',
    chainsymbol: 'BNB',
    chaindecimals: 18,
  },
];

const defaultethereumconflag = {
  testing: false,
  autoGasMultiplier: 1.5,
  defaultConfirmations: 1,
  defaultGas: '6000000',
  defaultGasPrice: '1000000000000',
  nodetimeout: 10000,
};

function web3ProviderFrom(endpoint, config) {
  return new ethers.providers.JsonRpcProvider(endpoint);
}

export function getDefaultProvider() {
  if (!provider) {
    provider = new ethers.providers.JsonRpcProvider(
      netlist[netid].rpcurl,
      netlist[netid].chaind
    );
  }
  return provider;
}

export function setNet(id) {
  netid = id;

  const chainId = netlist[netid].chaind;
  const rpcUrl = netlist[netid].rpcurl;

  // WalletConnect v2 configuration
  walletconnect = new WalletConnect({
    options: {
      projectId: WALLETCONNECT_PROJECT_ID,
      chains: [chainId],
      optionalChains: [1, 56, 97, 3],
      showQrModal: true,
      rpcMap: {
        [chainId]: rpcUrl,
      },
    },
  });

  injected = new InjectedConnector({
    supportedChainIds: [chainId],
  });
}

export function useWalletConnector() {
  const { activate, deactivate } = useWeb3React();
  const [provider, setProvider] = useState({});

  const setupNetwork = async () => {
    const provider = window.ethereum;
    if (provider) {
      try {
        await provider.request({
          method: 'wallet_switchEthereumChain',
          params: [
            {
              chainId: `0x${netlist[netid].chaind.toString(16)}`,
            },
          ],
        });
        setProvider(provider);
        return true;
      } catch (error) {
        return false;
      }
    } else {
      console.error(
        "Can't setup the Default Network network on metamask because window.ethereum is undefined"
      );
      return false;
    }
  };

  const loginMetamask = async () => {
    loginWallet(injected);
  };

  const loginWalletConnect = async () => {
    if (walletconnect) {
      try {
        await walletconnect.activate(netlist[netid].chaind);
      } catch (error) {
        console.log('WalletConnect error:', error.message);
      }
    }
  };

  const loginBSC = async () => {
    loginWallet(bsc);
  };

  const loginWallet = (connector) => {
    if (connector) {
      activate(connector, async (error) => {
        if (error instanceof UnsupportedChainIdError) {
          const hasSetup = await setupNetwork();
          if (hasSetup) {
            activate(connector);
          }
        } else {
          if (error instanceof NoEthereumProviderError) {
            console.log('Network Provide Error');
          } else if (error instanceof UserRejectedRequestErrorInjected) {
            console.log('Authorization Error! Please authorize to access your account');
          } else {
            console.log(error.name + error.message);
          }
        }
      });
    } else {
      console.log('Unable to find connector! The connector config is wrong');
    }
    setProvider(connector);
  };

  const logoutWalletConnector = () => {
    deactivate(provider, async (error) => {
      console.log(error);
      return false;
    });
    if (walletconnect) {
      try {
        walletconnect.deactivate();
      } catch (e) {
        // ignore
      }
    }
    return true;
  };

  return {
    loginMetamask,
    loginWalletConnect,
    loginBSC,
    logoutWalletConnector,
  };
}
